module.exports = __webpack_public_path__ + "assets/img/badge@2x.e1c5b136.png";